import {
    Box,
    CustomerLogos as MarketistCustomerLogos,
    type CustomerLogosProps as MarketistCustomerLogosProps,
    type Languages,
} from '@doist/marketist'

import { useTranslation } from 'app/i18n/client'
import cn from 'clsx'
import { CompanyLogo } from 'components/company-logo/company-logo'
import { useLocale } from 'next-intl'
import { getCompanyLogos } from 'services/cloudinary/company-logos'

import css from './customer-logos.module.css'

type CustomerLogosProps = Omit<MarketistCustomerLogosProps, 'logos'> & {
    includeDoistLogo?: boolean
    className?: string
}

function CustomerLogos({
    className,
    color,
    blockSize,
    includeDoistLogo = false,
}: CustomerLogosProps) {
    const locale = useLocale()
    const { i18n } = useTranslation(locale, 'common')

    const logos = getCompanyLogos(i18n.language as Languages, includeDoistLogo)
    const companyLogosImages = logos.map((logo) => (
        <CompanyLogo key={`company-${logo.id}`} logo={logo} />
    ))

    return (
        <Box className={cn(className, css.customerLogosContainer)}>
            <MarketistCustomerLogos
                logos={companyLogosImages}
                color={color}
                blockSize={blockSize}
            />
        </Box>
    )
}

export { CustomerLogos }
